<template lang="pug">
  v-card.mx-auto(
    max-width="1200"
    flat
    color="transparent"
  )
    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Сортировка"
            full-width
            v-model="sortModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Название"
            full-width
            v-model="nameModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Описание"
            full-width
            v-model="descriptionModel"
          )

      v-row.mb-0(align="center") Можно загружать только картинки формата svg
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-img(
            v-if="image!==''"
            :src="image"
          )
        input(
          @change="onImageChanged($event)"
          accept="image/*"
          type="file"
        )

</template>

<script>

export default {
  props: {
    sort: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
  methods: {
    onImageChanged(val) {
      this.$emit('imageChanged', val)
    },
  },
  computed: {
    sortModel: {
      get() {
        return this.sort
      },

      set(val) {
        this.$emit('sortChanged', val)
      },
    },
    nameModel: {
      get() {
        return this.name
      },

      set(val) {
        this.$emit('nameChanged', val)
      },
    },
    descriptionModel: {
      get() {
        return this.description
      },

      set(val) {
        this.$emit('descriptionChanged', val)
      },
    },
  },

}
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 400px;
}
</style>
